<template>
  <!-- 话务管理-服务指标统计 -->
  <basic-container>
    <div :style="'height:' + (bodyHeight - 155) + 'px; overflow: scroll;'">
      <!-- 搜索表单 -->
      <el-form ref="searchFormRef" label-width="100px">
        <el-row>
          <el-col span="12">
            <el-form-item label="日期：">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" size="small" @click="searchReset"> 清空 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 内容 -->
      <div class="content">
        <div class="box" v-for="content in contents" :key="content.title">
          <div class="title">{{ content.title }}</div>
          <div class="list" :class="`col-${content.col}`">
            <div class="item" v-for="item in content.list" :key="item.label">
              <span>{{ item.label }}</span>
              <span>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getProjectListApi } from '@/api/call-system/index';
import { getMetricsDataApi } from '@/api/call-system/call-manage/service-metrics-statistics';

export default {
  data() {
    return {
      projectId: '', // 项目id
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      /* 指标内容 */
      contents: [
        {
          title: '业务数量',
          col: 3,
          list: [
            {
              label: '呼入次数',
              value: 239,
            },
            {
              label: '呼入通话次数',
              value: 198,
            },
            {
              label: '未接次数',
              value: 41,
            },
            {
              label: '阻塞次数',
              value: 35,
            },
            {
              label: '排队次数',
              value: 35,
            },
            {
              label: '排队放弃次数',
              value: 24,
            },
          ],
        },
        {
          title: '系统效率',
          col: 2,
          list: [
            {
              label: '平均接续时间',
              value: '53s',
            },
            {
              label: '平均语音导航时间',
              value: '35s',
            },
            {
              label: '平均排队时间',
              value: '56s',
            },
            {
              label: '平均应答速度',
              value: '9s',
            },
          ],
        },
        {
          title: '业务效率',
          col: 3,
          list: [
            {
              label: '平均通话时间',
              value: '6分30秒',
            },
            {
              label: '平均事后处理时间',
              value: '1分20秒',
            },
            {
              label: '平均应答速度',
              value: '8秒',
            },
            {
              label: '工作速度',
              value: '9秒',
            },
            {
              label: '坐席使用率',
              value: '60%',
            },
          ],
        },
        {
          title: '外线使用情况',
          col: 3,
          list: [
            {
              label: '可用外线数',
              value: '3',
            },
            {
              label: '外线占用数',
              value: '0',
            },
            {
              label: '呼入数',
              value: '239',
            },
            {
              label: '呼出数',
              value: '189',
            },
            {
              label: '空闲数',
              value: '2',
            },
            {
              label: '使用率',
              value: '60%',
            },
          ],
        },
        {
          title: '坐席使用情况',
          col: 3,
          list: [
            {
              label: '登录坐席数',
              value: '5',
            },
            {
              label: '坐席分机占用数',
              value: '3',
            },
            {
              label: '坐席员占用数',
              value: '5',
            },
            {
              label: '排队等待数',
              value: '2',
            },
            {
              label: '使用率',
              value: '100%',
            },
          ],
        },
        {
          title: 'IVR使用情况',
          col: 3,
          list: [
            {
              label: 'TVR通道总数',
              value: '9',
            },
            {
              label: '占用数',
              value: '6',
            },
            {
              label: '呼入占用数',
              value: '3',
            },
            {
              label: '呼出占用数',
              value: '3',
            },
            {
              label: '空闲数',
              value: '0',
            },
            {
              label: '使用率',
              value: '100%',
            },
          ],
        },
      ],
    };
  },
  created() {
    getProjectListApi().then(({ data }) => {
      if (data.length > 0) {
        this.projectId = data[0].id;
        this.loadData();
      }
    });
  },
  methods: {
    /* 加载数据 */
    loadData() {
      if (!this.projectId) return;
      getMetricsDataApi(Object.assign({ projectId: this.projectId }, this.searchForm)).then(
        ({ data }) => {
          // todo
        }
      );
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {};
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      this.dealDateRange();
      this.loadData();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.timeStart = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        this.searchForm.timeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.timeStart = '';
        this.searchForm.timeEnd = '';
        this.dateRange = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 20px;
  row-gap: 20px;

  .box {
    height: auto;
    padding: 10px;
    border: 1px solid #d3d4d5;

    .title {
      line-height: 36px;
    }

    .list {
      display: grid;
      column-gap: 10px;
      row-gap: 10px;

      .item {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        background: #f5f7fa;
        padding: 5px 10px;
        height: 60px;
      }
    }
    .col-3 {
      grid-template-columns: repeat(3, 1fr);
    }
    .col-2 {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
